import React from "react";
import { Link } from "gatsby";
import { RichText } from "prismic-reactjs";
import styled from "@emotion/styled";
import dimensions from "styles/dimensions";
import colors from "styles/colors";
import PropTypes from "prop-types";
import Button from "../components/_ui/Button"

const CTACardContainer = styled(Link)`
    display: grid;
    grid-template-columns: 4fr 4fr;
    box-shadow: 0px 9px 24px rgba(0, 0, 0, 0.06);
    margin: 2em 0;
    transition: all 150ms ease-in-out;
    text-decoration: none;
    color: currentColor;

    @media(max-width:950px) {
        grid-template-columns: 7fr 4fr;
    }

    @media(max-width:${dimensions.maxwidthTablet}px) {
        grid-template-columns: 1fr;
    }

    @media(max-width:${dimensions.maxwidthMobile}px) {
        margin-bottom: 2em;
    }

    &:hover {
        box-shadow: 0px 9px 24px rgba(0, 0, 0, 0.1);
        transition: all 150ms ease-in-out;

        .CTACardAction {
            color: ${colors.blue500};
            transition: all 150ms ease-in-out;

            span {
                transform: translateX(0px);
                opacity: 1;
                transition: transform 150ms ease-in-out;
            }
        }

        .CTACardContent::before {
            opacity: 0.02;
            transition: all 150ms ease-in-out;
        }

        .CTACardImageContainer::before {
            opacity: 0.2;
            transition: all 150ms ease-in-out;
        }
    }
`

const CTACardContent = styled("div")`
    background: white;
    padding: 4em 3em 2.25em 3em;
    position: relative;

    &:before {
        position: absolute;
        content: "";
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: ${colors.blue500};
        mix-blend-mode: multiply;
        opacity: 0;
        transition: all 150ms ease-in-out;
    }

    @media(max-width:950px) {
        padding: 3.25em 2.5em 2em 2.5em;
    }

    @media(max-width:${dimensions.maxwidthTablet}px) {
        grid-row: 2;
    }
`

const CTA = styled("div")`

    margin-top: 24px;

    @media(min-width: ${dimensions.minwidthTablet}px) {
      margin-top: 2em;
    }

    @media(min-width: ${dimensions.minwidthDesktop}px) {
      margin-top: 2em;
      padding-bottom: 2em;
    }

    a {
    }

    button {
      
      .button-init {
        
      }
    }
`

const CTACardTitle = styled("h2")`
    margin-bottom: 0.5em;
    margin-top: 0.5em;
`

const CTACardBlurb = styled("div")`
    margin-bottom: 0.5em;
    margin-top: 0.5em;
    margin-bottom: 5em;

    @media(max-width:${dimensions.maxwidthTablet}px) {
        margin-bottom: 2.5em;
    }
`

const CTACardAction = styled("div")`
    font-weight: 600;
    text-decoration: none;
    color: currentColor;
    transition: all 150ms ease-in-out;

    span {
        margin-left: 1em;
        transform: translateX(-8px);
        display: inline-block;
        transition: transform 400ms ease-in-out;
    }
`

const CTACardImageContainer = styled("div")`
    background: ${colors.grey200};
    display: flex;
    justify-content: center;
    align-items: flex-end;
    overflow: hidden;
    position: relative;
    /* padding-left: 2em;
    padding-right: 2em; */

    @media(max-width:${dimensions.maxwidthTablet}px) {
        /* padding-top: 3em; */
        max-height: 200px;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
    }

    &:before {
        position: absolute;
        content: "";
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: ${colors.blue500};
        mix-blend-mode: multiply;
        opacity: 0;
        transition: all 150ms ease-in-out;
    }

    img {
        /* max-width: 400px; */
        width: 100%;
        box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.04);

        @media(max-width:${dimensions.maxwidthTablet}px) {
            /* max-width: 300px; */
        }
    }
`

const CTACard = ({ title, copy, image, link_text, link_target }) => (
    <CTACardContainer to='/'
        data-sal="zoom-out"
        data-sal-duration="300"
        data-sal-delay="150"
        data-sal-easing="ease-out"
    >
        <CTACardContent className="CTACardContent">
            <CTACardTitle>
                {RichText.render(title)}
            </CTACardTitle>
            <CTACardBlurb>
                {RichText.render(copy)}
            </CTACardBlurb>
            <CTA>
                <a href={link_target}>
                <Button className="button-init">
                    <span>{RichText.asText(link_text)}</span>
                </Button>
                </a>
            </CTA>
        </CTACardContent>
        <CTACardImageContainer className="CTACardImageContainer">
            <img src={image.url} alt={image.alt}/>
        </CTACardImageContainer>
    </CTACardContainer>
)

export default CTACard;

CTACard.propTypes = {
    title: PropTypes.array.isRequired,
    copy: PropTypes.array.isRequired,
    image: PropTypes.string.isRequired
}